export default __webpack_public_path__ + "static/media/group4721012-k26.f6803220.svg";